/**
 * 查看大图组件
 * 2019-7-29
 * Bai.Zhiming
 */
angular.module("imShowBigImageModule", []).
controller("imShowBigImageCtrl", ["$scope", "$element", '$timeout', function($scope, $element, $timeout) {
    initStatus();
    initData();
    /**
     * [initData description] 初始化状态
     * @return {[type]} [description]
     */
    function initData() {}
    /**
     * [close description] 关闭窗口
     * @return {[type]} [description]
     */
    $scope.close = function() {
        $scope.status.showBigImage = false;
    };
    /**
     * [initStatus description] 初始化数据
     * @return {[type]} [description]
     */
    function initStatus() {
        let status = {};
        let data = {};
        angular.extend($scope.status, status);
        angular.extend($scope.data, data);
        watcherShow();
        initKeyboardEsc();
    }
    /**
     * [initKeyboardEsc description] 初始化键盘退出事件
     * @return {[type]} [description]
     */
    function initKeyboardEsc() {
        window.addEventListener("keyup", esc);
        $scope.$on("$destroy", () => {
            window.removeEventListener("keyup", esc);
        });
        /**
         * [esc description] 退出查看
         * @return {[type]} [description]
         */
        function esc(e) {
            if (e.keyCode != 27) return;
            $timeout(() => {
                $scope.status.showBigImage = false;
            });
        }
    }
    /**
     * [watcherShow description] 监控第一次显示
     * @return {[type]} [description]
     */
    function watcherShow() {
        let watcher = $scope.$watch("status.showBigImage", (newV, oldV) => {
            if (newV) {
                dragAndDrop();
            }
        });
    }
    /**
     * [dragAndDrop description] 支持弹窗拖拽功能
     * @return {[type]} [description]
     */
    function dragAndDrop() {
        $timeout(() => {
            let $myElement = ($element[0].nodeName != "#comment") ? $element : $element.next().eq(0);
            $myElement.find("img").draggable({
                containment: ".im_show_big_image",
                handle: "",
                start(event, ui) {},
                stop() {}
            }, 1000);
        });
    }
}]);